import { Flex, Heading } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import RichTextEditor from "react-rte";
import { EMPTY_RTE } from "../../../CustomTextArea/CustomRTE";
import PreviewTextArea from "../../../CustomTextArea/PreviewTextArea";
import "../../../CustomTextArea/rte.css";

const QualitativePreview = ({ measure, key1, key2 }) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap="small">
      <Flex.Item>
        <Heading level="h3">
          {`${measure.name ?? t("assessment.qualitativeMeasure")}`}{" "}
        </Heading>
      </Flex.Item>
      {((measure.instructions && measure.instructions !== EMPTY_RTE) ||
        measure.description) && (
        <Flex.Item padding="0 0 0 large">
          <RichTextEditor
            className="readOnlyClass"
            readOnly
            value={RichTextEditor.createValueFromString(
              measure.instructions ? measure.instructions : measure.description,
              "html"
            )}
          />
        </Flex.Item>
      )}
      <Flex.Item padding="0 0 0 large">
        <PreviewTextArea
          id={`preview-measure-${key1}-${key2}`}
          label={<Heading level="h4">{t("results.measureEvidence")}</Heading>}
          defaultValue={t("results.measurePreviewHtml")}
        />
      </Flex.Item>
    </Flex>
  );
};

export default QualitativePreview;
